import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { List, Stack } from "@mui/material";

function Account(props) {
  const {
    user,
    open,
    handleShowAccount,
    setUser,
    setSection,
    showAccount,
  } = props;


  const openExternal = (url) => {
    const ua = navigator.userAgent || "";

    const isWebView =
      ua.includes("wv") ||
      (ua.includes("Android") && !ua.includes("Chrome")) ||
      (ua.includes("iPhone") && !ua.includes("Safari"));

    if (isWebView) {
      // mobile app → redirect 
      window.location.href = url;
    } else {
      // browser → new tab
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const handleLogout = () => {
    setUser({ id: 0 });
    localStorage.clear();
    setSection(1);
    handleShowAccount();
  };

  const handleClose = () => {
    showAccount(false);
  };

  const handleDeleteAccount = () => {
    openExternal("https://findmycones.com/account/delete-account");
  };

  const handleGoToProfile = () => {
    openExternal("https://findmycones.com/account/my-profile");
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="xs">
      <List component="div" role="group" sx={{ position: "relative" }}>
        <div
          style={{
            fontSize: "12px",
            position: "absolute",
            right: "11px",
            color: "#bbb6b6",
          }}
        >
          build 3.0.0
        </div>

        <ListItem>
          <ListItemText primary="Account" />
        </ListItem>

        <Divider />

        <ListItem>
          <ListItemText
            primary={user?.name || "User"}
            secondary={user?.orgName || "No Organization"}
          />
        </ListItem>
      </List>

      <Stack spacing={1} sx={{ p: 2 }}>
        <Button onClick={handleGoToProfile} variant="outlined">
          My Account
        </Button>

        <Button onClick={handleLogout} variant="outlined">
          Logout
        </Button>

        <Button onClick={handleDeleteAccount} variant="contained" color="error">
          Delete Account
        </Button>
      </Stack>
    </Dialog>
  );
}

export default Account;
